import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Divider from '@mui/material/Divider';
import { Box, Typography } from '@mui/material';

const s:any = {
  root: {
    marginTop: 8,
    marginBottom: 4,
  },
  label: {
    display: 'block',
    fontSize: 12,
    color: '#556070',
    marginBottom: 4,
  },
  inputWrap: {
    border: '1px solid #c8ccd4',
    borderRadius: 4,
    padding: '10px 12px',
    backgroundColor: '#fff',
  },
  input: {
    width: '100%',
    border: 'none',
    outline: 'none',
    fontSize: 16,
    background: 'transparent',
  },
  hide:{
    display:'none',
  },
};

class FPhoneField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: this.toDisplayValue(props.value)
    };
  }

  componentDidUpdate(prevProps:any) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.toDisplayValue(this.props.value) });
    }
  }

  toDisplayValue = (value:any) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (raw.startsWith('+')) return raw;
    const digits = raw.replace(/[^\d]/g, '');
    return digits ? `+${digits}` : '';
  };

  toStoredValue = (value:any) => {
    return String(value || '').replace(/[^\d]/g, '');
  };

  handleChange = (value:any) => {
    const { onChange } = this.props;
    this.setState({ value: value || '' });
    const normalized = this.toStoredValue(value);
    if(typeof onChange === 'function') onChange(normalized);
  };

  render() {
    const {id,label,required,options={},divider,classes } = this.props;
    const {value} = this.state;
    const { type, ...phoneOptions } = options || {};

    return (
      <React.Fragment>
        <Box sx={{ ...s.root }}>
          <Typography component='label' htmlFor={id} sx={{ ...s.label }}>
            {label}{required ? ' *' : ''}
          </Typography>
          <Box sx={{ ...s.inputWrap }}>
            <PhoneInput
              id={id}
              defaultCountry='GH'
              international={true}
              countryCallingCodeEditable={false}
              value={value || undefined}
              onChange={this.handleChange}
              className='phone-input-root'
              numberInputProps={{
                name: id,
                required,
                style: s.input,
              }}
              {...phoneOptions}
            />
          </Box>
        </Box>
        {divider && <Divider />}
      </React.Fragment>
    );
  }
}

FPhoneField.propTypes = {
  classes: PropTypes.object,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FPhoneField;
